import { RowSelectionState } from "@tanstack/react-table";

export enum SkillsPanelTab {
  Chart = "chart",
  Ungrouped = "ungrouped",
  ByProficiency = "byProficiency",
  ByFramework = "byFramework"
}

export type SkillsViewCommonProps = {
  canEditSkills: boolean;
  rowSelectionState: RowSelectionState;
  setRowSelectionState: (state: RowSelectionState) => void;
  searchTerm: string;
  setSearchTerm: (searchTerm: string) => void;
};
